import { Card, CardContent, CardHeader } from '@mui/material';
import * as React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ColumnInfo, GenericGrid, hasValue } from '@amsanalytics/react-shared-library';
import { IAmsPreviousLoanData } from "../../../Interfaces/Common/IAmsPreviousLoanData";

export interface PreviousAmsLoansCardProps {
  previousAmsLoans: IAmsPreviousLoanData[];
  canViewLoanDetails: boolean; // Only baseline loan info or all the details
}

// Card to display previous AMS loan information. Not applications. Just loans that were posted.
export const PreviousAmsLoansCard: React.FC<PreviousAmsLoansCardProps> = (props) => {
  // We can hide these columns if the client doesn't want some users to see how the loans are coming along
  const detailFieldsToHide = ["status", "code", "balance", "isItLate", "numberOfLatePaymentsPast0Days", "numberOfLatePaymentsPast5Days"];
  let columnsToDisplayForUser: ColumnInfo[] = [
    { title: "Loan Number", field: "loanNumber" },
    { title: "Status", field: "status" },
    { title: "Code", field: "code" },
    { title: "Balance", field: "balance", format: '{0:c}' },
    { title: "Contract Date", field: "contractDate", format: '{0:MMMM d, yyyy}' },
    { title: "Searched With", field: "searchedWith" },
    { title: "Matched Names", field: "matchedNames" },
    { title: "Matched Values", field: "matchedValues" },
    { title: "Matched Roles", field: "matchedRoles" },
    // { title: "Late", field: "isItLate" },
    // { title: "Late > 0", field: "numberOfLatePaymentsPast0Days" },
    // { title: "Late > 5", field: "numberOfLatePaymentsPast5Days" },
  ];
  if (!props.canViewLoanDetails) {
    columnsToDisplayForUser = columnsToDisplayForUser.filter(c => hasValue(c.field) && !detailFieldsToHide.includes(c.field!));
  }

  return (
    <Card style={{ backgroundColor: 'inherit', minHeight: 150, margin: '5px 0', overflowY: 'auto' }}>
      <CardHeader
        style={{ background: '#ffc800', padding: '0.2rem .8rem' }}
        avatar={<InfoOutlinedIcon />}
        title={`Previous AMS Loans (${props.previousAmsLoans.length})`}
      />
      <CardContent style={{ padding: '10px' }}>
        <GenericGrid<IAmsPreviousLoanData>
          style={{ display: 'flex', flex: 1 }}
          columns={columnsToDisplayForUser}
          items={props.previousAmsLoans.map(pal => {
            return { ...pal, contractDate: new Date(pal.contractDate) }
          })}
          disableAdding
          disableEditing
          disableExcelExporting
          disablePdfExporting
          disableFiltering
          disableGrouping
          size={"small"}
        />
      </CardContent>
    </Card>
  );
}
